import EventRowItemV4 from './EventRowItemV4';
import RewardImageV4 from './RewardImageV4';
import EllipsisText from '../../common/component/EllipsisText';
import SingleText from '../../common/component/SingleText';
import {REGION} from '../../common/constant';
import {IRewardItemV4} from '../type';

interface IProps {
  item: IRewardItemV4;
  isEmphasis: boolean;
}

export default function RewardItemV4({item, isEmphasis}: IProps) {
  const {label, title, subTitle, reward, isCompleted, isBgPurple} = item;
  const isKorea = REGION === 'kor';

  return (
    <EventRowItemV4
      className="gap-x-10"
      leftElementClassName={cn({
        'opacity-40': isCompleted,
        'gap-y-6': isEmphasis,
        'gap-y-3': !isEmphasis,
      })}
      rightElementClassName={cn({
        'flex-[0_0_130px] h-[130px]': isEmphasis,
        'flex-[0_0_70px] h-70': !isEmphasis,
      })}
      leftElement={
        <>
          {isEmphasis && (
            <SingleText
              className="s12-bold-white leading-14 tracking-[-0.4px]"
              data-testid="reward-label"
            >
              {label}
            </SingleText>
          )}
          <EllipsisText
            line={isEmphasis ? 3 : 2}
            className={cn({
              's18-bold-white leading-23 tracking-[-0.5px]': isEmphasis,
              's14-bold-white tracking-[-0.4px]': !isEmphasis,
              'leading-18': isKorea && !isEmphasis,
              'leading-22': !isKorea && !isEmphasis,
            })}
            data-testid="reward-title"
          >
            {title}
          </EllipsisText>
          <EllipsisText
            line={2}
            className={cn('s12-regular-white leading-14', {
              'tracking-[-0.5px] opacity-70': isEmphasis,
              'tracking-[-0.4px] opacity-80': !isEmphasis,
            })}
            data-testid="reward-sub-title"
          >
            {subTitle}
          </EllipsisText>
        </>
      }
      rightElement={
        <RewardImageV4
          isCompleted={isCompleted}
          isEmphasis={isEmphasis}
          isBgPurple={isBgPurple}
          rewardImage={reward.image}
        />
      }
    />
  );
}
